(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
(function () {
  var f = document.querySelector('[data-track-form]');
  if (!f) return;
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var base = f.getAttribute('data-track-base') || '';
    var val = (f.querySelector('input').value || '').trim();
    if (!base) return;
    var url;
    if (base.indexOf('{id}') > -1) {
      url = base.replace('{id}', encodeURIComponent(val));
    } else if (val) {
      url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'awb=' + encodeURIComponent(val);
    } else {
      url = base;
    }
    window.open(url, '_blank', 'noopener');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-feature"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vfeat__player').forEach(function (p) {
  var v = p.querySelector('video'), b = p.querySelector('.vfeat__play');
  if (!v || !b) return;
  b.addEventListener('click', function () { v.play(); p.classList.add('is-playing'); });
  v.addEventListener('pause', function () { p.classList.remove('is-playing'); });
  v.addEventListener('ended', function () { p.classList.remove('is-playing'); });
});

  } catch(e) { console.error(e); }
})();
})();
